<template>
  <div class="leaflets-container">
    <Breadcrumb :items="breadCrumbs" />
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />
    <v-container>
      <CategoryTitle :category="category" />
      <leaflets-slider :parent-leaflet-type-id="1" />
    </v-container>
    <category-block
      :target="category"
      position="position2"
      class="category-block category-block-2"
    />
    <category-block
      :target="category"
      position="position3"
      class="category-block category-block-3"
    />

    <v-container>
      <ebsn-meta
        :target="category"
        path="category_info.FOOTER_DESCRIPTION"
        tag="div"
      />
    </v-container>
  </div>
</template>
<script>
import Breadcrumb from "@/components/navigation/Breadcrumb";
import categoryMixin from "~/mixins/category";
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import LeafletsSlider from "@/components/leaflet/LeafletsSlider.vue";

export default {
  name: "Leaflets",
  components: {
    Breadcrumb,
    CategoryTitle,
    LeafletsSlider
  },
  mixins: [categoryMixin],
  data() {
    return {
      breadCrumbs: [
        { to: { name: "Home" }, text: "Homepage", exact: true },
        { text: "Volantini" }
      ]
    };
  }
  // async mounted() {
  //   this.category = this.$route.params.category;
  // }
};
</script>
